<!-- Answer button component -->
<button class="answer-button" (click)="sendOptions(answer)" [ngClass]="selected ? 'selected-answer-button': ''" [disabled]="selected">{{ answer }}</button>